module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/7_.png").default
        },
        {
            "time": 700,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/8_.png").default
        },
        {
            "time": 800,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/9_.png").default
        },
        {
            "time": 900,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/10_.png").default
        },
        {
            "time": 1000,
            "image": require("@frog/source/assets/images/bomber-tactics/units/red/death/11_.png").default
        },
        {
            "time": 1100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/empty.png").default
        }
    ]
}
